"use client";
import styles from "./MediaBackground.module.scss";
import useWindowSize from "@/hooks/useWindowSize";
import { Options_Modul_Text_mit_Bildhintergrund } from "@aleksundshantu/gp-types/acf-module-options";
import { Modul_Text_mit_Bildhintergrund } from "@aleksundshantu/gp-types/acf-module";

type MediaBackgroundTextClientProps = {
  children: React.ReactNode;
  text_color: Options_Modul_Text_mit_Bildhintergrund["text_color"];
  type: Options_Modul_Text_mit_Bildhintergrund["type"];

  box_opacity: Options_Modul_Text_mit_Bildhintergrund["box_opacity"];
  overlay_background_color: Options_Modul_Text_mit_Bildhintergrund["overlay_background_color"];
  background_color_class: Modul_Text_mit_Bildhintergrund["layout"]["background_color_class"];
  row_direction_class_mobile: Modul_Text_mit_Bildhintergrund["layout"]["row_direction_class_mobile"];
};

export const MediaBackgroundTextClient = ({
  children,
  text_color,
  box_opacity,
  type,
  overlay_background_color,
  background_color_class,
  row_direction_class_mobile,
}: MediaBackgroundTextClientProps) => {
  const { width } = useWindowSize();
  const isDesktop = width > 1024;
  return (
    <>
      <div
        className={styles["text-overlay"]}
        style={{
          background:
            type === "overlay-box" || !isDesktop
              ? `var(--${overlay_background_color}) `
              : "transparent",
          opacity:
            isDesktop || row_direction_class_mobile === "is-overlay"
              ? box_opacity
              : 1,
        }}
      ></div>
      <div
        className={`is-fractional-container is-1-2-container ${isDesktop && background_color_class ? background_color_class || "" : ""} ${styles["content-wrapper"]} ${type === "overlay-box" ? styles["overlay-box"] : ""} `}
        style={
          isDesktop
            ? ({
                background: "transparent",
                "--text-color": `var(--${text_color})`,
              } as React.CSSProperties)
            : {}
        }
      >
        {children}
      </div>
    </>
  );
};
